module.exports = __webpack_public_path__ + "img/23.547e0ff8.svg";